module.exports = __webpack_public_path__ + "static/columnHeaderNo-597f1be569461639e8fc30639d15f3b9.png";